import _ from 'lodash'
import activityTypesHelper from '../enums/activityTypes'

export function formatRawActivitiesForFront(data) {
  if (data.length > 0) {
    const rawActivityArray = []
    data.forEach((rawActivity) => {
      rawActivityArray.push(formatRawActivity(rawActivity))
    })
    return rawActivityArray
  } else {
    return formatRawActivity(data)
  }
}

function formatRawActivity(data) {
  return {
    rawActivityId: data.rawActivityId,
    name: data.name,
    tags: data.tags,
    activityType: data.activityType,
    imgSrc: data.imgSrc,
    imgPartOfTheQuestion: data.imgPartOfTheQuestion,
    allowedAttempts: data.allowedAttempts ? parseInt(data.allowedAttempts) : 4, // value  on the slider for "Infinite"
    points: data.points,
    difficulty: data.difficulty,
    orderNumber: data.orderNumber,
    requiredActivitiesBefore: data.requiredActivitiesBefore,
    activationTime: data.activationTime,
    onCompletionAction: data.onCompletionAction,
    content: data.content,
    timeToAnswer: data.timeToAnswer
  }
}

function displayContentForActivityType(rawActivity, withLockStatus = true) {
  let content = ''
  const rawActivityObject = rawActivity.content
  switch (rawActivity.activityType) {
    case activityTypesHelper.ACTIVITY_TYPES.QUIZ:
      content += '<ul>'
      content += '<li><strong>Question:</strong> ' + rawActivityObject.question + '</li>'
      content += '<li><strong>Answer type:</strong> ' + formatAnswersTypeForQuiz(rawActivityObject.type) + '</li>'

      if (rawActivityObject.type === 'free-text') {
        content += '<li><strong>Answer:</strong> <u>' + rawActivityObject.correctAnswer + '</u></li>'
      }
      if (rawActivityObject.type === 'one-answer') {
        content += '<li><strong>Answers:</strong> ' + formatAnswersForQuiz(rawActivityObject.answers, rawActivityObject.correctAnswer) + '</li>'
      }

      if (withLockStatus) {
        content += '<li><strong>Lock status:</strong> ' + formatLock(rawActivityObject.unlocked_forced) + '</li>'
      }

      if (rawActivityObject.explanation) {
        content += '<li><strong>Explanation:</strong> ' + rawActivityObject.explanation + '</li>'
      }
      content += '</ul>'
      break
    case activityTypesHelper.ACTIVITY_TYPES.PHOTO:
      content += '<ul>'
      content += '<li><strong>Text:</strong> ' + rawActivityObject.question

      if (withLockStatus) {
        content += '<li><strong>Lock status:</strong> ' + formatLock(rawActivityObject.unlocked_forced) + '</li>'
      }

      content += '</ul>'
      break
    case activityTypesHelper.ACTIVITY_TYPES.UNLOCK_ONLY:
      content += '<ul>'
      content += '<li><strong>Text:</strong> ' + rawActivityObject.question + '</li>'
      content += '</ul>'
      break
    default:
      content = rawActivity.content
      break
  }

  return content
}

function formatAnswersTypeForQuiz(type) {
  switch (type) {
    case 'one-answer':
      return 'One correct answer'
    case 'free-text':
      return 'Free text'
    case 'multiple-answers':
      return 'Multiple correct answers'
    default:
      return 'Unknown'
  }
}

function formatAnswersForQuiz(answers, correctAnswer) {
  let answArray = _.values(answers)
  _.updateWith(answArray, [correctAnswer - 1], function (t) {
    return '<u>' + t + '</u>'
  })
  return _.join(answArray, ', ')
}

function formatLock(lock) {
  return lock === true ? '<span style="color:#73b895">UNLOCKED</span>' : '<span style="color:#c55558">LOCKED</span>'
}

function formatBooleanWithIcon(val) {
  return val ? {
    icon: 'checkbox-marked',
    color: '#73b895',
    class: 'is-success',
    text: 'TRUE'
  } : {icon: 'close-box-outline', color: '#c55558', class: 'is-danger', text: 'FALSE'}
}

function unlockIcon(unlocked) {
  return unlocked ? {icon: 'lock-open-outline', style: '#74b996'} : {icon: 'lock', style: '#c55558'}
}

export default {
  formatRawActivitiesForFront,
  displayContentForActivityType,
  formatBooleanWithIcon,
  unlockIcon,
}
